import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom'
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { createCompanyCohort, getCompanyCohorts, getCompanyUsers } from '../../modules/Company';
import { LoadingSpinnerPage } from '../../components/atomic/Loaders/LoadingSpinner';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import InfoCard from '../../components/molecule/Cards/InfoCard';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
`;

const Header = styled.div`
  margin: 20px;
  font-size: 20px;
  font-weight: 600;
`;

const GridContainer = styled(Grid)`
  flex: 1;
  flex-grow: 1;
`;

const GridColumn = styled(Grid)`
  flex: 1;
  margin: 0 6px;
`;

const ColumnHeader = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: 600;
`;

const InfoCardStyled = styled(InfoCard)`
  margin: 4px 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

class CohortList extends Component {
  constructor(props) {
    super(props);
    const {
      companyState: {
        companies
      },
      location: {
        state
      },
      match: {
        params: {
          uid
        }
      }
    } = props;

    const thisCompany = state && state.company
      ? state.company
      : companies.find(item => item.id === parseInt(uid));

    this.state = {
      company: thisCompany,
    };
  }

  async componentDidMount() {
    const {
      getCompanyCohorts,
      getCompanyUsers,
      match: { params: { uid } }
    } = this.props;

    await getCompanyCohorts({ id: uid });
    await getCompanyUsers({ id: uid });
  }

  renderCohortCard = (item, index) => {
    const { history } = this.props;
    const { company } = this.state;

    const starts = item.program && item.program.start_date
      ? `, starts: ${item.program.start_date}` : '';

    const subtext2 = item.program
      ? `Program: ${item.program.name}${starts}` : null;

    return (
      <InfoCardStyled
        key={`cohort-${index}-${item.id}`}
        header={item.name}
        subtext1={`${item.members.length} members(s)`}
        subtext2={subtext2}
        onClick={() => history.push(`/digital-coaching/${company.id}/cohort/${item.id}`, {
          cohort: item, company
        })}
      />
    );
  }

  renderUserCard = (item, index) => {
    return (
      <InfoCardStyled
        key={`users-${index}-${item.id}`}
        header={item.email}
        subtext1={item.user && `Name: ${item.user.name}`}
      />
    );
  }

  renderCohortList = () => {
    const {
      companyState: {
        companyCohorts,
      }
    } = this.props;
    const { company: { id } } = this.state;

    return companyCohorts[id].map((item, index) => {
      return this.renderCohortCard(item, index);
    });
  }

  renderUserList = () => {
    const {
      companyState: {
        companyUsers,
      }
    } = this.props;
    const { company: { id } } = this.state;

    return companyUsers[id].map((item, index) => {
      return this.renderUserCard(item, index);
    });
  }

  createCohort = async () => {
    const { createCompanyCohort, history } = this.props;
    const { company } = this.state;

    const today = new Date();

    const cohort = await createCompanyCohort({
      name: today.toISOString().split('T')[0],
      company: company.id,
    });

    history.push(`/digital-coaching/${company.id}/cohort/${cohort.id}`, { cohort, company });
  }

  render() {
    const {
      companyState: {
        companyCohorts,
        companyCohortsLoading,
        companyUsers,
        companyUsersLoading,
      }
    } = this.props;
    const { company: { id, name } } = this.state;

    return (companyCohortsLoading || companyUsersLoading) ? (
      <LoadingSpinnerPage />
    ) : (
      <Container spacing={8}>
        <Header><Link to="/digital-coaching">Companies</Link> &raquo; {name}</Header>
        <GridContainer container spacing={8}>
          <GridColumn item>
            <ColumnHeader>Cohorts</ColumnHeader>
            { (companyCohorts[id] && companyCohorts[id].length > 0) && (
              <>{this.renderCohortList()}</>
            )}
            <ButtonContainer>
              <Button color='primary' variant='contained' onClick={this.createCohort}>
                <Icon>add</Icon> Add New Cohort
              </Button>
            </ButtonContainer>
          </GridColumn>
          <GridColumn item>
            <ColumnHeader>Users</ColumnHeader>
            { (companyUsers[id] && companyUsers[id].length > 0) && (
              <>{this.renderUserList()}</>
            )}
          </GridColumn>
        </GridContainer>
      </Container>
    )
  }
}

CohortList.propTypes = {
};

CohortList.defaultProps = {
};

function mapStateToProps(state) {
  return {
    companyState: state.companyState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createCompanyCohort,
    getCompanyCohorts,
    getCompanyUsers,
  }, dispatch)
}


export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(CohortList);
